/* eslint-disable no-console */
import React from "react";

export default React.createContext({
	data: null,
	container: null,
	run: fn => {
		console.warn("Cannot run function in di-context, due it is not provided");
		console.log({ fn: fn && (fn.name || fn.toString()) });
	},
});
